module.exports = __webpack_public_path__ + "media/images/help-center/help-center-icon-general-7eb5d91feef065fcb93edc0da8a53c88.png";